module.exports = __webpack_public_path__ + "static/img/hrbb.eb700b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/hrbb.png
// module id = hnGh
// module chunks = 93